import type { ReactNode } from 'react';
import { Result, Typography } from 'antd';
import { ToolOutlined } from '@ant-design/icons';
import { useMaintenanceMode } from '../../hooks/useMaintenanceMode';

const { Text } = Typography;

interface MaintenanceOverlayProps {
  children: ReactNode;
}

/**
 * Fullscreen-заглушка «Технические работы».
 * Показывается когда feature flag `maintenance_mode` включён.
 * Админы видят приложение как обычно.
 */
export function MaintenanceOverlay({ children }: MaintenanceOverlayProps) {
  const { isMaintenanceMode } = useMaintenanceMode();

  if (!isMaintenanceMode) {
    return <>{children}</>;
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 24,
        background: 'var(--color-bg-primary)',
      }}
    >
      <Result
        icon={<ToolOutlined style={{ color: 'var(--color-warning)' }} />}
        title="Технические работы"
        subTitle="Мы обновляем систему. Пожалуйста, попробуйте зайти через несколько минут."
        extra={
          <Text type="secondary">
            Страница обновится автоматически, когда работы завершатся.
          </Text>
        }
      />
    </div>
  );
}
